import React from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import Header from './Header';
import theme from './Theme';

class AppLayout extends React.Component {
    renderChildren(children) {
        return children.map();
    }

    render() {
        return (
            <MuiThemeProvider theme={theme}>
                <Header />

                <Grid container className="root" spacing={8}>
                    <Grid item sm={4} xs={12}>
                        <Paper className="paper">{this.props.left}</Paper>
                    </Grid>
                    <Grid item sm={8} xs={12}>
                        <Paper className="paper">{this.props.right}</Paper>
                    </Grid>
                </Grid>
            </MuiThemeProvider>
        );
    }
}

export default AppLayout;



// WEBPACK FOOTER //
// ./src/Layout.js